export * from './src/resize.module';
export * from './src/resize/interface';
export { ResizeComponent } from './src/resize/resize.component';
